import { Injectable } from '@angular/core';
import { HttpClient ,HttpHeaders} from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { DataService } from '../../../services/data.service';
import{Customer} from '../../../POS/models/customer';
import{OrderMaster} from '../../../POS/models/order-master';
import { CashTransaction } from 'src/app/models/cash-transaction';
import { CommonFunctionService, UserMerchantData, UserPOSData} from '../../../services/Common/common-function.service';
import { TransactionDetailModel } from 'src/app/models/transaction-detail-model';
import { catchError, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {
  userId: any;
  token;
  headers: any;
  constructor(private service: DataService, private http: HttpClient, private common:CommonFunctionService) {
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token =environment.GetAuthenticationToken + ":" +this.common.GetAuthToken()+ ":" + "IT"+ ":"+environment.GetAuthencticationKey+":"+this.common.getSid()+":"+merchantdata.MerchantKeyId;  ;
     this.headers = new HttpHeaders().
    set('Authorization', 'basic ' + btoa(this.token));
  }
  AddCustomer(data)
  {
    this.GetGeaderdetails();
    return this.http.post<Customer>(environment.AddCustomerUrl,data,{headers:this.headers});
  }
  UpdateCustomer(data) {
    this.GetGeaderdetails();
    return this.http.post<Customer>(environment.UpdateCustomerUrl,data,{headers:this.headers});

  }
  GetCustomerDetail(data) {
    return this.http.get<Customer>(environment.GetCustomerDetailUrl + "?PosSubscriptionId=" + data.PosSubscriptionId+"&id="+data.id,{headers:this.headers})
    .pipe(map(response => response),catchError(this.common.handleError));
  }
  
  GetCustomerIDDetail(data) {
    this.GetGeaderdetails();
    return this.http.get<Customer>(environment.GetCustomerIDDetail + "?PosSubscriptionId=" + data.PosSubscriptionId+"&id="+data.id,{headers:this.headers})
    .pipe(map(response => response),catchError(this.common.handleError));
  }
  GetcustomerMobiledetails(data) {
    this.GetGeaderdetails();
    return this.http.get<Customer>(environment.GetCustomermobileDetail + "?PosSubscriptionId=" + data.PosSubscriptionId+"&email="+data.Email +"&Mobilenumber="+data.MobileNumber,{headers:this.headers})
    .pipe(map(response => response),catchError(this.common.handleError));
  }
  GetCustomerid(data) {
    this.GetGeaderdetails();
    return this.http.get<Customer>(environment.GetCustomerEmailDetail + "?PosSubscriptionId=" + data.PosSubscriptionId+"&email="+data.Email +"&Mobilenumber="+data.MobileNumber,{headers:this.headers})
    .pipe(map(response => response),catchError(this.common.handleError));
  }
  
  
  GetCustomerEmailVerfication(data) {
    this.GetGeaderdetails();
    return this.http.get<Customer>(environment.GetCustomerEmailVerfication + "?PosSubscriptionId=" + data.PosSubscriptionId+"&Email="+data.id,{headers:this.headers})
    .pipe(map(response => response),catchError(this.common.handleError));
  }

  GetOrderManagement(data) {
    this.GetGeaderdetails();
    return this.http
      .post(environment.GetordermanagementListUrl + "?PosSubscriptionId=" + data,{headers:this.headers})
      .pipe(map(response => response),catchError(this.common.handleError));
  }


  // GetOrderdetails(data) {
  //   return this.service
  //     .getAll(environment.Getorderdetails + "?PosSubscriptionId=" + data.PosSubscriptionId+"&id="+data.id)
  //     .map(response => response);
  // }
  GetOrderdetails(data) {
    this.GetGeaderdetails();
        return this.http.get<any>(environment.Getorderdetails + "?PosSubscriptionId=" + data.PosSubscriptionId+"&id="+data.id,{headers:this.headers})  
        .pipe(map(response => response),catchError(this.common.handleError));
      
  }
//   VieworderTransactionDetails(data,MerchantKeyId,batchId,paymentType)
// {
//   return this.http.get<TransactionDetailModel>(environment.getTransactionDetailsByTypeUrl+"?id="+data+"&MerchantKeyId="+MerchantKeyId+"&BatchId="+batchId+"&PaymentType="+paymentType)  
//   .map(response => response)    
//   .catch(this.common.handleError);
// } 

VieworderTransactionDetails(data,MerchantKeyId){
  this.GetGeaderdetails();
  const merchantdata: UserMerchantData = this.common.getUserMerchantData();
  return this.http.get<any>(environment.getTransactionSummaryDetailsUrl+"?merchantKeyId="+MerchantKeyId
  +"&transactionid="+ data +"&LoginUserId="+merchantdata.UserId
  ,{headers:this.headers});
}

  GetCashTransactionDetail(data)
  {
    this.GetGeaderdetails();
    return this.http.get<any>(environment.GetCashTransactionDetail + "?PosSubscriptionId=" + data.PosSubscriptionId+"&ordeId="+data.orderId,{headers:this.headers})  
    .pipe(map(response => response),catchError(this.common.handleError));
    
  }


  NewOrder(data)
  {
    this.GetGeaderdetails();
    return this.http.post(environment.AddOrders, data,{headers:this.headers});
  }
  Getdetails(data)
  {
    this.GetGeaderdetails();
    return this.http
    .post(environment.Getdetails + "?PosSubscriptionId=" + data.PosSubscriptionId+"&id="+data.id,{headers:this.headers})
    .pipe(map(response => response),catchError(this.common.handleError));
  }
  GetCustomerList(data) {
    this.GetGeaderdetails();
    return this.http
      .post(environment.GetCustomerListUrl + "?PosSubscriptionId=" + data,{headers:this.headers})
      .pipe(map(response => response),catchError(this.common.handleError));
  }
  GetCustomerListUrl(data)
  {
    this.GetGeaderdetails();
    return this.http.get<any>(environment.GetCustomerListUrl + "?PosSubscriptionId=" + data,{headers:this.headers})
  }
  FilteringCustomerDetails (PosSubscriptionId,Fromdate1,todate1,cname,cid,cemail,cmobile)
  {
    this.GetGeaderdetails();
    return this.http
    .get<any>( environment.FilteringCustomerDetails+"?PosSubscriptionId="+PosSubscriptionId+"&fromdate="+Fromdate1+"&todate="+todate1+"&customerName="+ 
      cname+"&customerid="+ cid +"&customeremail="+cemail+"&customermobile="+cmobile,{headers:this.headers})
      .pipe(map(response => response),catchError(this.common.handleError));
  }

  GetordermanagementListUrl(data)
  {
    this.GetGeaderdetails();
    return this.http.get<any>(environment.GetordermanagementListUrl + "?PosSubscriptionId=" + data,{headers:this.headers})
  }
 
  FilteringOrderDetails(data)
    {
      this.GetGeaderdetails();
      return this.http.post<any>(environment.FilteringOrderDetails,data,{headers:this.headers})
    }


    GetGeaderdetails()
    {
      let loggedUsername =this.common.getUserName()
      const merchantdata: UserMerchantData = this.common.getUserMerchantData();
      this.token =environment.GetAuthenticationToken + ":" +this.common.GetAuthToken()+ ":" + "IT"+ ":"+environment.GetAuthencticationKey+":"+this.common.getSid()+":"+merchantdata.MerchantKeyId;  ;
        this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
  
    }

    CallGenerateEinvoice(data) {
      const merchantdata: UserMerchantData = this.common.getUserMerchantData();
      this.GetGeaderdetails();
          return this.http.get<any>(environment.CallGenerateEinvoice + "?PosSubscriptionId=" + data.PosSubscriptionId+"&id="+data.id+"&MerchantKeyId="+merchantdata.MerchantKeyId,{headers:this.headers})  
          .pipe(map(response => response),catchError(this.common.handleError));
    }
    PrintEwayBillDetails(data) {
      const aspid = "1707123622";
      const password = "Fastswiff@2022";
      this.GetGeaderdetails();
         var result= this.http.post<any>(environment.PrintEwayBillDetails + "?aspid=" + aspid + "&password=" + password + 
          "&Gstin=36AAACX0240Q1Z5",data,{headers:{'Content-Type': 'application/json' }, },)  
        .pipe(map(response => response),catchError(this.common.handleError));   
        console.log(result);
        return result;     
    }
}
